import { SEARCHQUERY, FILTER } from "./actionTypes";

export const searchQuery = (query) => ({
  type: SEARCHQUERY,
  payload: query
});

export const filter = (filter) => ({
  type: FILTER,
  payload: filter
});